import { FC } from 'react'
import './post-seo-preview.styles.css'

export const TwitterSEOCard: FC<{
  title: string
  description: string
  domain: string
  thumbnailUrl?: string
  type?: 'summary_with_image' | 'summary'
}> = ({
  thumbnailUrl,
  title,
  description,
  domain,
  type = 'summary_with_image',
}) => {
  if (!thumbnailUrl || type === 'summary') {
    return (
      <div className="TwitterCardsGrid TwitterCard TwitterCard--animation">
        <div className="TwitterCardsGrid-col--12 TwitterCardsGrid-col--spacerBottom CardContent">
          <div className="SummaryCard--small TwitterCard-container u-block">
            <div
              className="SummaryCard-image TwitterCardsGrid-float--prev"
              style={{
                backgroundSize: 'cover',
                backgroundImage: `url(${thumbnailUrl})`,
              }}
            >
              {!thumbnailUrl && (
                <div className="tcu-imageContainer tcu-imageAspect--1to1">
                  <div className="tcu-imageWrapper"></div>
                </div>
              )}
            </div>
            <div className="SummaryCard-contentContainer TwitterCardsGrid-float--prev">
              <div className="SummaryCard-content TwitterCardsGrid-ltr">
                <h2
                  className="TwitterCard-title js-cardClick tcu-textEllipse--multiline"
                  dir="ltr"
                >
                  {title}
                </h2>

                <p
                  className="tcu-resetMargin u-block TwitterCardsGrid-col--spacerTop tcu-textEllipse--multiline"
                  dir="ltr"
                >
                  {description}
                </p>

                <span
                  className="u-block TwitterCardsGrid-col--spacerTop SummaryCard-destination"
                  dir="ltr"
                >
                  {domain}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="card-seo-twitter">
      <div
        className="card-seo-twitter__image"
        style={{ backgroundImage: `url(${thumbnailUrl})` }}
      ></div>
      <div className="card-seo-twitter__text">
        <span className="card-seo-twitter__title">{title}</span>
        <span className="card-seo-twitter__description">{description}</span>
        <span className="card-seo-twitter__link">{domain}</span>
      </div>
    </div>
  )
}
